<div class="connection-error">
    <div class="icon" tippy="Something went wrong connecting to the server">
        <img src="/assets/images/warning.svg"/>
    </div>

    <h2>Oopsie, Woopsie!</h2>
    <p>We made a fucksy upsy!</p>
    <p>{{ref.data.error}}</p>
</div>
